import { useMemo, useState } from "react";

import { getCastellerShortName } from "../../utils/castellerName";
import {
    getScheduledNotificationId,
    getScheduledRecipientOptions,
} from "./scheduledNotificationsUtils";
import ScheduledNotificationRow from "./scheduled/ScheduledNotificationRow";
import useScheduledNotificationEditor from "./scheduled/useScheduledNotificationEditor";
import useScheduledNotifications from "./scheduled/useScheduledNotifications";

function ScheduledNotifications({ socket, castellersInfo, user_names }) {
    const [loadNScheduledNotifications, setLoadNScheduledNotifications] = useState(10);
    const {
        cancelScheduledNotification,
        cancellationStatus,
        isLoading,
        loadScheduledNotifications,
        upcomingNotifications,
    } = useScheduledNotifications(socket);

    const userOptionsById = useMemo(() => (
        Object.fromEntries(user_names.map(user => [String(user.value), user]))
    ), [user_names]);

    const getRecipientOptions = notification => (
        getScheduledRecipientOptions(notification, userOptionsById)
    );

    const {
        cancelEditing,
        editState,
        editingNotificationId,
        saveEditing,
        saveStatus,
        startEditing,
    } = useScheduledNotificationEditor({
        getRecipientOptions,
        loadScheduledNotifications,
        socket,
    });

    const displayName = id => {
        if (!id) return '-';

        return castellersInfo[id] ?
            getCastellerShortName(castellersInfo[id]) :
            `Usuari ${id}`;
    };

    const visibleNotifications = upcomingNotifications.slice(0, loadNScheduledNotifications);

    return (
        <div className="scheduled-notifications-section">
            <h1>Notificacions programades</h1>

            {isLoading ? (
                <div className="notification-status">
                    <div className="loading">&nbsp;</div>
                    <p>Carregant notificacions programades...</p>
                </div>
            ) : null}

            {!isLoading && upcomingNotifications.length === 0 ? (
                <div className="scheduled-empty-state">
                    <i className="fas fa-clock"></i>
                    <p>No hi ha notificacions programades.</p>
                </div>
            ) : null}

            {upcomingNotifications.length > 0 ? (
                <>
                    <div style={{ width: '100%', overflowX: 'auto' }}>
                        <table className="notifications-log scheduled-notifications-table">
                            <thead>
                                <tr>
                                    <th>Enviador</th>
                                    <th>Receptors</th>
                                    <th>Títol (exemple)</th>
                                    <th>Missatge (exemple)</th>
                                    <th>Data programada</th>
                                    <th>Data activitat</th>
                                    <th>Accions</th>
                                </tr>
                            </thead>
                            <tbody style={{ fontSize: '0.8rem' }}>
                                {visibleNotifications.map(notification => {
                                    const notificationId = getScheduledNotificationId(notification);

                                    return (
                                        <ScheduledNotificationRow
                                            key={notificationId}
                                            cancellationStatus={cancellationStatus[notificationId]}
                                            castellersInfo={castellersInfo}
                                            displayName={displayName}
                                            editState={editState}
                                            isEditing={editingNotificationId === notificationId}
                                            notification={notification}
                                            onCancelEditing={cancelEditing}
                                            onCancelScheduledNotification={cancelScheduledNotification}
                                            onSaveEditing={saveEditing}
                                            onStartEditing={startEditing}
                                            saveStatus={saveStatus[notificationId]}
                                            user_names={user_names}
                                        />
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>

                    {loadNScheduledNotifications < upcomingNotifications.length ? (
                        <button
                            onClick={() => setLoadNScheduledNotifications(loadNScheduledNotifications + 10)}
                            style={{
                                width: '100%',
                                marginTop: 10,
                            }}
                        >
                            Carrega'n més
                        </button>
                    ) : null}
                </>
            ) : null}
        </div>
    );
}

export default ScheduledNotifications;
